import { z } from 'zod';

/** @see Arvato.eCoSystem.Framework.DataModels.ItemState */
export type InventoryStatus = z.infer<typeof inventoryStatusSchema>;

/** @see Arvato.eCoSystem.Framework.DataModels.ItemState */
export const inventoryStatusSchema = z.enum([
	'Unknown',
	'Orderable',
	'InStock',
	'OutOfStock',
	'BackOrderable',
	'Preorder',
	'Unavailable',
	'EndOfLife',
]);
